import * as React from 'react';
import { Skeleton } from '@grandvisionhq/iris-ui';

const ShippingMethodPlaceholder = ()=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "shipping-method-placeholder",
        role: "presentation"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "shipping-method-placeholder__method"
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        height: 48,
        width: 200,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "200",
        height: "24px",
        rx: "4",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "180",
        height: "16px",
        rx: "4",
        fill: "currentColor",
        y: "32"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "shipping-method-placeholder__logo"
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        height: 24,
        width: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "24px",
        height: "24px",
        rx: "4",
        fill: "currentColor"
    }))));
};

export { ShippingMethodPlaceholder };
//# sourceMappingURL=ShippingMethodPlaceholder.js.map
